import { message } from '@/App'
import axios from 'axios'
import { globalState, globalActions } from '@/store'
import { getRegion } from './region'

const request = axios.create({
  baseURL:
    import.meta.env.VITE_APP_CHAT_BASE_URL ||
    `${import.meta.env.VITE_APP_COMMON_BASE_URL}/zdtc-api`,
  timeout: 12000,
  headers: {},
})

request.interceptors.request.use(
  config => {
    const { userInfo } = globalState
    if (userInfo.authCode) {
      config.headers = Object.assign({}, config.headers, {
        authcode: userInfo.authCode,
        AgentToken: userInfo.agent_token,
      })
    }
    const region = getRegion()
    if (region) {
      config.headers = Object.assign({}, config.headers, {
        region,
      })
    }
    return config
  },
  error => {
    console.log('request error =>', error)
    return Promise.reject(error)
  },
)

// 添加响应拦截器
request.interceptors.response.use(
  response => {
    if (response.request.responseType === 'arraybuffer') {
      return Promise.resolve(response.data)
    }
    // 400 账号被封禁 401: 登录过期 402:禁言 403:ip 封禁
    if (
      [401, 403, 400].includes(response.data?.status) ||
      response.data?.message === '登录过期'
    ) {
      globalActions.logout()
      return Promise.reject(response.data)
    } else if (response.data?.status !== 1) {
      const errMessage = response?.data?.message || '请求失败'
      message.open({
        key: 'api',
        type: 'error',
        content: errMessage,
      })
      return Promise.reject(response.data)
    }

    return Promise.resolve(response.data)
  },
  error => {
    console.log('response error =>', error)
    let errMessage = error.message || '请求失败'

    if (error.response?.status === 401) {
      globalActions.logout()
      return
    }

    if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
      errMessage = '网络错误, 请稍后重试'
      if (error.config.url.includes('/query_recommend')) {
        return
      }
    }

    if (
      error.code === 'ECONNABORTED' ||
      (error.message && /timeout/.test(error.message))
    ) {
      errMessage = '网络超时, 请稍后重试'
    }

    if (!navigator.onLine) {
      errMessage = '您当前处于离线状态，请检查网络连接'
    }

    message.open({
      key: 'api',
      type: 'error',
      content: errMessage,
    })

    return Promise.reject(error)
  },
)

const commonRequest = axios.create({
  timeout: 12000,
  baseURL: import.meta.env.DEV ? import.meta.env.VITE_APP_COMMON_BASE_URL : '/',
  headers: {},
})

commonRequest.interceptors.request.use(
  config => {
    const { userInfo } = globalState
    if (userInfo?.authCode) {
      config.headers = Object.assign({}, config.headers, {
        authcode: userInfo.authCode,
      })
    }
    if (userInfo?.knowledge_token) {
      config.headers = Object.assign({}, config.headers, {
        Authorization: userInfo.knowledge_token,
      })
    }
    const region = getRegion()
    if (region) {
      config.headers = Object.assign({}, config.headers, {
        region,
      })
    }
    return config
  },
  error => {
    console.log('request error =>', error)
    return Promise.reject(error)
  },
)

// 添加响应拦截器
commonRequest.interceptors.response.use(
  response => {
    if (response.request.responseType === 'arraybuffer') {
      return Promise.resolve(response.data)
    }
    if (response.data?.code === 401 || response.data?.message === '登录过期') {
      globalActions.logout()
      return Promise.reject(response.data)
    } else if (response.data?.code !== 0) {
      const errMessage = response?.data?.message || '请求失败'
      message.open({
        key: 'api',
        type: 'error',
        content: errMessage,
      })
      return Promise.reject(errMessage)
    }

    return Promise.resolve(response.data)
  },
  error => {
    console.log('response error =>', error)
    let errMessage =
      error.response?.data?.message || error.message || '请求失败'

    if (error.response?.status === 401 || error.response?.data?.code === 401) {
      globalActions.logout()
      return
    }

    if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
      errMessage = '网络错误, 请稍后重试'
      if (error.config.url.includes('/query_recommend')) {
        return
      }
    }

    if (
      error.code === 'ECONNABORTED' ||
      (error.message && /timeout/.test(error.message))
    ) {
      errMessage = '网络超时, 请稍后重试'
    }

    if (!navigator.onLine) {
      errMessage = '您当前处于离线状态，请检查网络连接'
    }

    message.open({
      key: 'api',
      type: 'error',
      content: errMessage,
    })

    return Promise.reject(error)
  },
)

export { request, commonRequest }
